import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Input from '../Elements/Input/Input';
import Button from '../Elements/Button/Button';
import {
	addVoucher,
	voucherInputChange,
	removeVoucher,
	updateKlarna,
	updatePaymentMethod,
} from '../../actions/checkout';
import { translate } from '../../utils/locale';
import s from './Voucher.scss';

const Voucher = ({ setup, checkout, ...props }) => {
	const { selection } = checkout;

	const addVoucherHandler = (e) => {
		e.preventDefault();
		props.addVoucher().then((action) => {
			if (action.type === 'UPDATE_SELECTION') {
				props.updateKlarna();
			}
			return action;
		}).catch((err) => console.log('DEBUG: voucher not added', err));
		props.updatePaymentMethod();
	};

	const removeVoucherHandler = (e) => {
		e.preventDefault();
		const voucherId = e.currentTarget.dataset.voucher;
		props.removeVoucher(voucherId).then(() => props.updateKlarna()).catch((err) => console.log('DEBUG: voucher not removed', err));
		props.updatePaymentMethod();
	};

	const onVoucherInputChange = (id, value) => {
		props.voucherInputChange(value);
		props.updatePaymentMethod();
	};

	return (
		<div className={s.voucher}>
			<form onSubmit={addVoucherHandler}>
				<Input id="voucherCode" type="text" label={translate(setup, 'checkoutVoucherCode')} value={checkout.vouchers.currentValue} inputChange={onVoucherInputChange} width="calc(100% - 120px)" />
				<Button type="submit" text={translate(setup, 'checkoutVoucherUse')} />
				{ checkout.vouchers.error ? <div className={s.voucher_error}>{ translate(setup, 'checkoutVoucherError') }</div> : null }
				{
					selection.discounts && selection.discounts.vouchers.length > 0 && (
						<div className={s.voucher_added}>
							{
								selection.discounts.vouchers.map((voucher) => (
									<a key={voucher.voucher} className={s.voucher_added_row} href="#removeVoucher" data-voucher={voucher.voucher} onClick={removeVoucherHandler}>
										<span>{voucher.voucher}</span>
										<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
											<g fill="none" stroke="#000" strokeLinecap="square" strokeWidth="1.5" transform="rotate(-45 17.39 3.11)">
												<line x1="7.793" x2="7.793" y2="15" />
												<line x1="15" y1="7.707" y2="7.707" />
											</g>
										</svg>
									</a>
								))
							}
						</div>
					)
				}
			</form>
		</div>
	);
};

const mapState = (state, props) => ({ ...props });

export default hot(module)(connect(mapState, { addVoucher, voucherInputChange, removeVoucher, updateKlarna, updatePaymentMethod })(Voucher));
